var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 43.4,
    height: 43.4,
    rx: 21.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 43.4,
    height: 43.4,
    rx: 21.7,
    stroke: "#D4DDE7",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0001 23.1523L26.6091 27.7614C26.9273 28.0795 27.4432 28.0795 27.7614 27.7614C28.0795 27.4431 28.0795 26.9273 27.7614 26.609L23.1523 22L27.7614 17.3909C28.0795 17.0727 28.0795 16.5568 27.7614 16.2387C27.4432 15.9205 26.9273 15.9205 26.6091 16.2387L22.0001 20.8477L17.3909 16.2386C17.0727 15.9205 16.5568 15.9205 16.2386 16.2386C15.9205 16.5568 15.9205 17.0727 16.2386 17.3909L20.8477 22L16.2386 26.6091C15.9205 26.9273 15.9205 27.4431 16.2386 27.7614C16.5568 28.0795 17.0727 28.0795 17.3909 27.7614L22.0001 23.1523Z",
    fill: "#21272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.a6f4daf959d7d3c4aff563f0e14c2899.svg";
export { ForwardRef as ReactComponent };